import React from 'react';
import './CatalogOptions.scss';

const CatalogOptions = () => {
    const scrollToCatalog = (elementId) => {
        const el = document.getElementById(elementId);
        if (el) {
            window.scrollTo({
                top: el.offsetTop - 70,
                behavior: 'smooth'
            });
        }
    };

    return (
        <section className="catalog-options-section">
            <div className="catalog-options-container">
                {/* Card 1: Layanan Cetak Eksklusif (Custom) */}
                <div
                    className="catalog-option-card card-custom"
                    onClick={() => scrollToCatalog('packaging-catalog')}
                >
                    <div className="option-badge badge-custom">
                        <span className="badge-dot dot-green" />
                        <span className="badge-text">LAYANAN CETAK EKSKLUSIF</span>
                    </div>

                    <h3 className="option-title title-custom">
                        SUDAH PUNYA DESIGN SENDIRI?
                    </h3>

                    <p className="option-desc">
                        Custom sekarang! Anda bisa pilih sendiri jenis cup & ukuran. Setelah itu, akan ada tim operasional kami yang siap menghubungi kamu untuk approval design.
                    </p>

                    <button
                        type="button"
                        className="option-action-link link-custom"
                        onClick={(e) => {
                            e.stopPropagation();
                            scrollToCatalog('packaging-catalog');
                        }}
                    >
                        <span>Pilih Produk & Upload Design</span>
                        <svg className="action-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                        </svg>
                    </button>
                </div>

                {/* Card 2: Stok Siap Kirim Hari Ini (Polosan) */}
                <div
                    className="catalog-option-card card-polosan"
                    onClick={() => scrollToCatalog('ready-stock')}
                >
                    <div className="option-badge badge-polosan">
                        <span className="badge-dot dot-amber" />
                        <span className="badge-text">STOK SIAP KIRIM HARI INI</span>
                    </div>

                    <h3 className="option-title title-polosan">
                        BELI PRODUK CUP POLOSAN KAMI
                    </h3>

                    <p className="option-desc">
                        Tanpa sablon, ready stock ribuan dus, harga pabrik termurah untuk operasional harian.
                    </p>

                    <button
                        type="button"
                        className="option-action-link link-polosan"
                        onClick={(e) => {
                            e.stopPropagation();
                            scrollToCatalog('ready-stock');
                        }}
                    >
                        <span>Lihat Daftar Cup Polosan</span>
                        <svg className="action-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                        </svg>
                    </button>
                </div>
            </div>
        </section>
    );
};

export default CatalogOptions;
